export default __webpack_public_path__ + "static/media/modele_convention_1.de4b4944.xlsx";